module.exports = __webpack_public_path__ + "img/empty-bottom.36e2d8fe.png";